import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { NewdanhmucdangkiemAction } from 'src/actions/newdanhmucdangkiem.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    MenuItem,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    InputLabel,
    TableCell,
} from '@material-ui/core';

import Select from 'react-select';

import { Search as SearchIcon } from 'react-feather';

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
    SIM_TYPE_LIST_OBJ_WITHOUT_OPERATOR,
} from 'src/utils/constants';

import moment from 'moment';
import { isGrantPermission } from 'src/utils/utils';
import { NewdanhmucsanphamAction } from 'src/actions/newdanhmucsanpham.action';

const CreateEditDialog = (props) => {
    const dispatch = useDispatch()
    const { items } = useSelector(state => state.permission)
    const { selected } = useSelector(state => state.newdanhmucdangkiem)
    const { info, permissions, role } = useSelector(state => state.profile)
    const [so_khung, setSoKhung] = useState("")
    const [so_may, setSoMay] = useState("")
    const [mau_sac, setMauSac] = useState("")
    const [an_chi, setAnChi] = useState("")
    const [ghi_chu, setGhiChu] = useState("")
    const [ngay_xuat_xuong, setNgayXuatXuong] = useState("")
    const [ngay_tra_dang_kiem, setNgayTraDangKiem] = useState("")

    const [sanpham_id, setSanphamId] = useState("-99");
    const [sanpham_name, setSanphamName] = useState("");
    const [sanpham_select, setSanphamSelect] = useState(undefined);
    const [sanphamList, setSanphamList] = useState([]);

    const additionalOptionSanpham = { 'id': '-99', 'ma': 'Sản phẩm...', 'ten': '' };

    const fetchData = async() => {
        const _sanphamList = await dispatch(NewdanhmucsanphamAction.sanphamList());
        if (_sanphamList && typeof _sanphamList.data !== 'undefined' && typeof _sanphamList.data.values !== 'undefined') setSanphamList(_sanphamList.data.values);
    }

    useEffect(() => {
        if (props.open == true) {
            fetchData();

            resetState();

            if (props.type == 'EDIT' && selected) {
                setSoKhung(selected.so_khung)
                setSoMay(selected.so_may)
                setMauSac(selected.mau_sac)
                setAnChi(selected.an_chi)
                setGhiChu(selected.ghi_chu)
                setNgayXuatXuong(selected.ngay_xuat_xuong ? moment(selected.ngay_xuat_xuong).format('YYYY-MM-DD') : '')
                setNgayTraDangKiem(selected.ngay_tra_dang_kiem ? moment(selected.ngay_tra_dang_kiem).format('YYYY-MM-DD') : '')

                if (typeof selected.newdanhmucsanpham_ref !== 'undefined' && selected.newdanhmucsanpham_ref) {
                    const newValue = selected.newdanhmucsanpham_ref;

                    const productLine = `<div style="font-weight: bold">${newValue.ma} ${newValue.ten ? ` - ${newValue.ten}` : ''}</div>`;
                    const ncc = newValue.newdanhmucnhacungcap_ref
                        ? `<div>(${newValue.newdanhmucnhacungcap_ref.ma} - ${newValue.newdanhmucnhacungcap_ref.ten})<div>`
                        : null;
                
                    const html = `
                        <div>
                            ${productLine}
                            ${ncc}
                        </div>
                    `;
                    
                    setSanphamId(selected.newdanhmucsanpham_ref.id);
                    // setSanphamName(selected.newdanhmucsanpham_ref.ma + ' - ' + selected.newdanhmucsanpham_ref.ten + (typeof selected.newdanhmucsanpham_ref.newdanhmucnhacungcap_ref !== 'undefined' ? (' (' + selected.newdanhmucsanpham_ref.newdanhmucnhacungcap_ref.ma + ' - ' + selected.newdanhmucsanpham_ref.newdanhmucnhacungcap_ref.ten + ')') : ''));
                    setSanphamName(html);
                    setSanphamSelect(selected.newdanhmucsanpham_ref);
                }
            }
        }
    }, [props])

    const onPressPositive = () => {
        if (sanpham_id === "-99") {
            alert('Vui lòng chọn sản phẩm!');
            return;
        }

        if (so_khung === "") {
            alert('Vui lòng nhập số khung!');
            return;
        }

        if (so_may === "") {
            alert('Vui lòng nhập số_máy!');
            return;
        }

        if (props.type === 'EDIT') {
            dispatch(NewdanhmucdangkiemAction.update(selected.id, { 
                san_pham: sanpham_id,
                ngay_xuat_xuong,
                so_khung,
                so_may,
                mau_sac,
                an_chi,
                ghi_chu,
                ngay_tra_dang_kiem,
            }))
        } else {
            dispatch(NewdanhmucdangkiemAction.create({ 
                san_pham: sanpham_id,
                ngay_xuat_xuong,
                so_khung,
                so_may,
                mau_sac,
                an_chi,
                ghi_chu,
                ngay_tra_dang_kiem,
            }, props.creatingFromAway))
        }
        resetState();
        props.handleClose();
    }

    const resetState = () => {
        setSoKhung("");
        setSoMay("");
        setMauSac("");
        setAnChi("");
        setGhiChu("");
        setNgayXuatXuong("");
        setNgayTraDangKiem("");
        setSanphamId("-99");
        setSanphamName("");
        setSanphamSelect(undefined);
        setSanphamList([]);
    }

    return (
        <Dialog open={props.open} onClose={props.handleClose}>
            <DialogTitle>{props.type === 'EDIT' ? "Cập nhật bản ghi" : "Tạo bản ghi mới"}</DialogTitle>
            <DialogContent style={{ width: 600, paddingTop: 20 }}>
                <Grid
                    container
                    spacing={3}
                >
                    <Grid
                        item
                        md={12}
                        xs={12}
                    >
                        <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                            <Select
                                classNamePrefix="nt-select"
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({
                                        ...base,
                                        zIndex: 999999,
                                    }),
                                    control: (provided) => ({
                                        ...provided,
                                        height: 56,
                                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                    }),
                                    option: (provided) => ({
                                        ...provided,
                                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                    }),
                                }}
                                options={[additionalOptionSanpham, ...sanphamList]} // Thêm vào đầu danh sách
                                getOptionLabel={(item) =>
                                    `${item.ma + (item.ten ? (' - ' + item.ten) : '') + (typeof item.newdanhmucnhacungcap_ref !== 'undefined' ? (' (' + item.newdanhmucnhacungcap_ref.ma + ' - ' + item.newdanhmucnhacungcap_ref.ten + ')') : '')}`
                                }
                                formatOptionLabel={(item, { context }) => {
                                    const productLine = `${item.ma}${item.ten ? ` - ${item.ten}` : ''}`;
                                    const ncc = item.newdanhmucnhacungcap_ref
                                        ? `${item.newdanhmucnhacungcap_ref.ma} - ${item.newdanhmucnhacungcap_ref.ten}`
                                        : null;

                                    return (
                                        <div>
                                            <div class='limit-line limit-line-1' style={{ fontWeight: "bold" }}>{productLine}</div>
                                            {ncc && <div class='limit-line limit-line-1'>({ncc})</div>}
                                        </div>
                                    );
                                }}
                                // placeholder={(sanpham_id !== '-99' ? sanpham_id : 'Sản phẩm...') || "Sản phẩm..."}
                                placeholder={
                                    sanpham_id !== "-99"
                                        ? <span dangerouslySetInnerHTML={{ __html: sanpham_name }} />
                                        : <span style={{fontWeight: 'bold'}}>Sản phẩm...</span>
                                }
                                components={{
                                    DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                    IndicatorSeparator: null,
                                }}
                                value={sanpham_id || null}
                                // onChange={(newValue) => { setSanphamId(newValue.id); setSanphamName(newValue.ma + ' - ' + newValue.ten + (typeof newValue.newdanhmucnhacungcap_ref !== 'undefined' ? (' (' + newValue.newdanhmucnhacungcap_ref.ma + ' - ' + newValue.newdanhmucnhacungcap_ref.ten + ')') : '')); setSanphamSelect(newValue); }}
                                onChange={(newValue) => {
                                    const productLine = `<div style="font-weight: bold">${newValue.ma} ${newValue.ten ? ` - ${newValue.ten}` : ''}</div>`;
                                    const ncc = newValue.newdanhmucnhacungcap_ref
                                        ? `<div>(${newValue.newdanhmucnhacungcap_ref.ma} - ${newValue.newdanhmucnhacungcap_ref.ten})<div>`
                                        : null;
                                
                                    const html = `
                                        <div>
                                            ${productLine}
                                            ${ncc}
                                        </div>
                                    `;
                                
                                    setSanphamId(newValue.id);
                                    setSanphamName(html);
                                    setSanphamSelect(newValue);
                                }}
                                isSearchable
                            />
                        </div>
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Số khung"
                            name="so_khung"
                            onChange={(e) => setSoKhung(e.target.value)}
                            required
                            placeholder='RPBXMDEBFSV100042'
                            value={so_khung}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Số máy"
                            name="so_may"
                            onChange={(e) => setSoMay(e.target.value)}
                            required
                            placeholder='HFT48V450WR2240710987'
                            value={so_may}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Ngày xuất xưởng"
                            name="ngay_xuat_xuong"
                            onChange={(e) => setNgayXuatXuong(e.target.value)}
                            placeholder='YYYY-MM-DD'
                            value={ngay_xuat_xuong}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Ngày trả đăng kiểm"
                            name="ngay_tra_dang_kiem"
                            onChange={(e) => setNgayTraDangKiem(e.target.value)}
                            placeholder='YYYY-MM-DD'
                            value={ngay_tra_dang_kiem}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Màu sắc"
                            name="mau_sac"
                            onChange={(e) => setMauSac(e.target.value)}
                            placeholder='XANH'
                            value={mau_sac}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Ấn chỉ"
                            name="an_chi"
                            onChange={(e) => setAnChi(e.target.value)}
                            placeholder='1474413'
                            value={an_chi}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid
                        item
                        md={6}
                        xs={6}
                    >
                        <TextField
                            fullWidth
                            label="Ghi chú"
                            name="ghi_chu"
                            onChange={(e) => setGhiChu(e.target.value)}
                            placeholder='Trả'
                            value={ghi_chu}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose}>Huỷ</Button>
                <Button onClick={onPressPositive}>{props.type === 'EDIT' ? "Cập nhật" : "Tạo"}</Button>
            </DialogActions>
        </Dialog >
    );
}

export default CreateEditDialog;